import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const rateRequestListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'exchangeCurrencyFromId',
    label: 'From',
  },
  {
    name: 'exchangeCurrencyToId',
    label: 'To',
  },
  {
    name: 'maxDeviationPercent',
    label: 'Max. Deviation',
  },
  {
    name: 'active',
    label: 'Status',
  },
];

export const rateRequestListColumnsLabels = {
  exchangeCurrencyToId: 'Currency to',
  active: 'Status',
};

export const rateRequestListAllColumnsLabels = {
  exchangeCurrencyToId: 'Currency to',
  exchangeCurrencyFromId: 'Currency from',
  active: 'Status',
};

export const rateRequestListDefaultSorter = {};

export const rateRequestListSchema = {
  exchangeCurrencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const rateRequestListAllSchema = {
  exchangeCurrencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  exchangeCurrencyFromId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const rateRequestListFiltersSchema = [
  {
    name: 'exchangeCurrencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];

export const rateRequestListAllFiltersSchema = [
  {
    name: 'exchangeCurrencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'exchangeCurrencyFromId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];
